import { put } from 'redux-saga/effects';
import { fetchSearchApi } from 'common/api/search';
import { collectionSetInStoreAction } from 'common/actions/collection';
import { errorHandleAction } from 'components/error-handle/actions';
import { collectionIsLoadingAction } from 'common/actions';

export function* searchRequestEffect(action) {
  try {
    yield put(collectionIsLoadingAction());
    const { searchTerm, perPage, pageNum, sorting } = action.payload;
    const collection = yield fetchSearchApi({ searchTerm, perPage, pageNum, sorting });
    yield put(collectionSetInStoreAction(collection));
  } catch (error) {
    yield put(errorHandleAction(error, error.status));
  }
}

export function* searchRequestMobileEffect({ payload }) {
  try {
    yield put(collectionIsLoadingAction());
    const { searchTerm, perPage, prevVideos, sorting } = payload;

    let { pageNum } = payload;
    pageNum = ++pageNum;

    const collection = yield fetchSearchApi({ searchTerm, perPage, pageNum, sorting });

    if (pageNum > 1) {
      collection.videos = [].concat(prevVideos, collection.videos);
      collection.pageNum = pageNum;
    }

    yield put(collectionSetInStoreAction(collection));
  } catch (error) {
    yield put(errorHandleAction(error, error.status));
  }
}
